import { SHOP_LEVELS, ShopLevel } from "./shopGame.ts";

/*
 * The one thing Shop Rush keeps besides the best scores (ADR 0131 §5, §7): the grade last
 * chosen, so the page opens on it. The scores live with every other game's in
 * bestScore.ts. Same read-validate / try-write habit as mergeStore.ts: nothing leaves
 * the browser, and a full or disabled store costs nothing but the memory. The pace is
 * not kept: the page always opens on Calm.
 */
const STORAGE_KEY = "mathpages.shopGame";

/** The page opens on Grade 2 until a grade has been chosen. A level saved under the old bands ("g25", "g68") is not one of the grades, so it opens Grade 2 too (ADR 0131 §7). */
export const DEFAULT_SHOP_LEVEL: ShopLevel = "g2";

export function readShopLevel(): ShopLevel {
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        const parsed = stored ? JSON.parse(stored) : null;
        if (parsed && typeof parsed === "object" && SHOP_LEVELS.includes(parsed.level)) {
            return parsed.level;
        }
    } catch {
        // Unavailable or unreadable: the default.
    }
    return DEFAULT_SHOP_LEVEL;
}

export function saveShopLevel(level: ShopLevel): void {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ level }));
    } catch {
        // Full, disabled, or unavailable. A level is not worth an error.
    }
}
